import React from "react";
import getCodedValue from "../../utils/getCodedValue";

const Language = ({ data }) => (
  <div>
    <h4>Language</h4>
    {data.map(({ language }, index) => (
      <div key={index}>{getCodedValue(language)}</div>
    ))}
  </div>
);

export default Language;
